import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=997a7efe&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('997a7efe')) {
      api.createRecord('997a7efe', component.options)
    } else {
      api.reload('997a7efe', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=997a7efe&", function () {
      api.rerender('997a7efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-203o1cdn0pv03/JS/comp/ErrorMessage.vue"
export default component.exports